import { createStore } from 'vuex'
import org from '@trust/modules/org'
import walletConnectStore from '@shared/modules/walletConnect'
import sounds from '@trust/modules/sounds'
import trust from '@trust/modules/trust'
import routingStore from '@trust/modules/routing'
import stationsStore from '@trust/modules/stations'
import lrftStore from '@trust/modules/lrft'

// Create a new store instance.
const store = createStore({
  modules: {
     org: org,
     walletConnect: walletConnectStore,
     sounds: sounds,
     trust: trust,
     routing: routingStore,
     stations: stationsStore,
     lrft: lrftStore,
  }
})
export default store;
